import { Component, Input, ViewChild } from "@angular/core";
import { ProductAttributes, ProductQueryCategory } from "@models/product.model";
import { RightNavbarComponent } from "../../dashboard/right-navbar/right-navbar.component";

@Component({
    selector: "app-best-sellers-section",
    templateUrl: "./best-sellers-section.component.html",
    styleUrl: "./best-sellers-section.component.scss",
    standalone: false,
})
export class BestSellersSectionComponent {
    @Input() bestSellerProducts: ProductAttributes[] = [];
    @ViewChild(RightNavbarComponent) rightNavbarComponent!: RightNavbarComponent;

    public isNavbarOpen: boolean = false;
    public productQueryCategory = ProductQueryCategory;

    public setNavbarOpen(isOpen: boolean): void {
        this.isNavbarOpen = isOpen;
    }

    public onCloseNavbar() {
        this.isNavbarOpen = false;
    }
}
